module.exports = __webpack_public_path__ + "assets/e10b4e6fd34f79c665f7795299df9d5a.mp3";